import React from 'react';

const TimeRange = props => {
    return (
        <div className='my-3'>
            <div className='form-group row'>
                <label className='col-5 col-form-label col-form-label-sm text-right'
                    htmlFor='timeMinus'>
                    - (minus)</label>
                <div className='col-7 input-group align-items-center'>
                    <input type='number'
                        className='form-control form-control-sm rounded-0 bg-transparent text-light'
                        id='timeMinus'
                        aria-describedby=''
                        name='timeMinus'
                        value={props.minus}
                        onChange={props.onChange}
                        placeholder='hours'
                        min={0}
                        max={12} />&nbsp;hour(s)
                </div>
            </div>
            <div className='form-group row'>
                <label className='col-5 col-form-label col-form-label-sm text-right'
                    htmlFor='timePlus'>
                    + (plus)</label>
                <div className='col-7 input-group align-items-center'>
                    <input type='number'
                        className='form-control form-control-sm rounded-0 bg-transparent text-light'
                        id='timePlus'
                        aria-describedby=''
                        name='timePlus'
                        value={props.plus}
                        onChange={props.onChange}
                        placeholder='hours'
                        min={1}
                        max={12} />&nbsp;hour(s)
                </div>
            </div>
        </div>
    );
}

export default TimeRange;
